/*
  <hover-video> custom element.
  Plays its inner <video> when the parent product card is hovered,
  and pauses/resets when the pointer leaves. Does nothing on touch
  devices or when the user prefers reduced motion, so no video data
  is ever downloaded there (the <video> uses preload="none").
*/
if (!customElements.get('hover-video')) {
  customElements.define(
    'hover-video',
    class HoverVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.canHover = window.matchMedia('(hover: hover)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.trigger = this.closest('.card-wrapper') || this;

        this.onEnter = this.play.bind(this);
        this.onLeave = this.reset.bind(this);

        this.trigger.addEventListener('mouseenter', this.onEnter);
        this.trigger.addEventListener('mouseleave', this.onLeave);
        // Keyboard users tabbing into the card link.
        this.trigger.addEventListener('focusin', this.onEnter);
        this.trigger.addEventListener('focusout', this.onLeave);
      }

      play() {
        if (!this.canHover.matches || this.reduceMotion.matches) return;
        const promise = this.video.play();
        if (promise !== undefined) {
          promise.catch(function () {
            /* Autoplay can be blocked; safe to ignore. */
          });
        }
      }

      reset() {
        if (!this.video) return;
        this.video.pause();
        try {
          this.video.currentTime = 0;
        } catch (e) {
          /* currentTime not always settable before metadata loads. */
        }
      }

      disconnectedCallback() {
        if (!this.trigger) return;
        this.trigger.removeEventListener('mouseenter', this.onEnter);
        this.trigger.removeEventListener('mouseleave', this.onLeave);
        this.trigger.removeEventListener('focusin', this.onEnter);
        this.trigger.removeEventListener('focusout', this.onLeave);
      }
    }
  );
}